import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { phoneOnChange, updateMobileNumber } from "./actions";
import { toggleCTA } from "../../login/phone_number/actions";
import SharedPropsService from "../../../SharedPropsService";
import { isDarkModeTheme, RegexConfig } from "../../../configs/config";
import { heightMap } from "../../../configs/height";
import { goBack } from "../otp_CAS/actions";
let isDarkMode = isDarkModeTheme();
export const template = (prevMob) => ({
    layout: {
        id: ROUTE.UPDATE_PHONE_NUMBER,
        type: LAYOUTS.MODAL,
        style: {
            height: heightMap[ROUTE.UPDATE_PHONE_NUMBER],
        },
        widgets: [
            { id: "headerStack", type: WIDGET.STACK },
            { id: "space1", type: WIDGET.SPACE },
            { id: "text2", type: WIDGET.TEXT },
            { id: "space20", type: WIDGET.SPACE },
            { id: "input", type: WIDGET.INPUT },
            { id: "space3", type: WIDGET.SPACE },
            {
                id: "continue",
                type: WIDGET.BUTTON,
                position: POSITION.FIXED_BOTTOM,
            },
        ],
    },
    datastore: {
        headerStack: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: "text", type: WIDGET.TEXT },
                { id: "leadIcon", type: WIDGET.BUTTON },
            ],
        },
        leadIcon: {
            id: 'bt_getPortfolioScreen_cancel',
            label: "",
            type: ButtonTypeTokens.SmallGhost,
            width: ButtonWidthTypeToken.CONTENT,
            stack: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
            },
            labelColor: ColorTokens.Grey_Night,
            icon: {
                name: IconTokens.Cross,
                align: IconAlignmentTokens.right,
                size: IconSizeTokens.XXL,
            },
            action: {
                type: ACTION.GO_BACK,
                payload: {
                    value: "",
                    widgetId: "input",
                    isResend: false,
                },
                routeId: ROUTE.UPDATE_PHONE_NUMBER,
            },
        },
        text: {
            label: "Edit mobile number",
            fontWeight: "700",
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.MD,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
        },
        text2: {
            label: "Use mobile number linked to your investments",
            fontSize: FontSizeTokens.SM,
            fontWeight: "400",
            fontFamily: FontFamilyTokens.Inter,
            color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Night,
        },
        space0: { size: SizeTypeTokens.XXXXL },
        continue: {
            id: 'bt_getPortfolioScreen_updatePhoneNumber',
            label: "Update mobile number",
            fontFamily: FontFamilyTokens.Inter,
            type: prevMob ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.FULL,
            height: 40,
            fontSize: FontSizeTokens.MD,
            action: {
                type: ACTION.EDIT_MOBILE_NUMBER,
                payload: {
                    value: "",
                    targetWidgetId: "mobileItem",
                },
                routeId: ROUTE.UPDATE_PHONE_NUMBER,
            },
        },
        input: {
            id: 'tf_getPortfolioScreen_phoneNumber',
            value: prevMob,
            onlyNumeric: true,
            regex: RegexConfig.MOBILE,
            type: InputTypeToken.MOBILE,
            state: InputStateToken.DEFAULT,
            isDarkMode: isDarkMode ? true : false,
            title: "Mobile number",
            charLimit: 10,
            placeholder: "Enter mobile number",
            keyboardType: KeyboardTypeToken.numberPad,
            action: {
                type: ACTION.PHONE_NUMBER_ONCHANGE,
                payload: { value: "", targetWidgetId: "input" },
                routeId: ROUTE.UPDATE_PHONE_NUMBER,
            },
            caption: { error: "Enter a 10 digit mobile number" },
            errorAction: {
                type: ACTION.DISABLE_CONTINUE,
                routeId: ROUTE.UPDATE_PHONE_NUMBER,
                payload: { value: false, targetWidgetId: "continue" },
            },
            successAction: {
                type: ACTION.ENABLE_CONTINUE,
                routeId: ROUTE.UPDATE_PHONE_NUMBER,
                payload: { value: true, targetWidgetId: "continue" },
            },
        },
        space1: { size: SizeTypeTokens.MD },
        space3: { size: SizeTypeTokens.XXXL },
        space20: {
            size: SizeTypeTokens.XXL
        }
    },
});
export const updateMobileNumberMF = {
    onLoad: async () => {
        const prevMob = `${(await SharedPropsService.getUser()).linkedBorrowerAccounts[0].accountHolderPhoneNumber.replace("+91", "")}`;
        return Promise.resolve(template(prevMob));
    },
    actions: {
        [ACTION.EDIT_MOBILE_NUMBER]: updateMobileNumber,
        [ACTION.PHONE_NUMBER_ONCHANGE]: phoneOnChange,
        [ACTION.ENABLE_CONTINUE]: toggleCTA,
        [ACTION.DISABLE_CONTINUE]: toggleCTA,
        [ACTION.GO_BACK]: goBack,
    },
};
